import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getBudgetPlannerReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportBudgetPlanner } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class BudgetPlanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    cleanSearch = () => {
        this.props.clearFormInput(`CategorySalesBranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    downloadReport = () => {
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let branch = this.props.branch || this.props.loggedBranch;
        let budget = this.props.budget || 0;
        if (budget > 0) {
            this.props.getBudgetPlannerReport({ branch, budget });
        } else {
            alert('budget must greater than 0!');
        }

    }
    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        return (
            <Grid headerContent={reportBudgetPlanner}>
                <PageHeader 
                    title={LOOKUP.report.budgetPlannerReport.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-budget-planner-report" />}
                    description={LOOKUP.report.budgetPlannerReport.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body
                            budgetPlanner={this.props.budgetPlanner}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                        />
                        <Pagination
                            // length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        budgetPlanner: state.reports.budgetPlanner,
        loggedBranch: state.common.branchId,
        branch: state.form.BudgetPlannerBranchOption,
        budget: state.form.BudgetPlannerBudget
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getBudgetPlannerReport: model => dispatch(getBudgetPlannerReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(BudgetPlanner));